export default "__VITE_ASSET__d7d$OsEu__"